import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotificationsComponent } from './notifications/notifications.component';
import { AuthGuard } from 'app/gaurds/auth.guard';
import { RolesGuard } from 'app/gaurds/roles.guard';

const routes: Routes = [
  {
    path: '',
    component: NotificationsComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: {
      allowedRoles: ['pmo', 'admin']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationsRoutingModule { }
